"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingType = void 0;
var SharingType;
(function (SharingType) {
    SharingType["SharedByMe"] = "sharedByMe";
    SharingType["SharedWithMe"] = "sharedWithMe";
})(SharingType || (exports.SharingType = SharingType = {}));
//# sourceMappingURL=interface.js.map